//成功失败弹窗
import $fetchql from "./fetch";

let toastnum = 0;

function showSuccess (message, time) {
  time = time ? time : 5;
  let num = toastnum++;
  $('body').append(`<div class="toastk succ_toast toast_${num}"><span class="toast_text">${message}</span></div>`);
  setTimeout(() => {
    $('.toast_' + num).remove();
  }, time * 1000)
}

function showError (message, time) {
  time = time ? time : 5;
  let num = toastnum++;
  $('body').append(
    `<div class="toastk err_toast toast_${num}"><img class="toast_erricon" src="./static/img/err_icon.png" alt=""><span class="toast_text">${message}</span><img class="toast_closeicon" src="./static/img/close_icon20.png" alt=""></div>`
  );
  setTimeout(() => {
    $('.toast_' + num).remove();
  }, time * 1000)
}

var confimnum = 0;

function showconfim (obj) {
  confimnum++;
  var num = confimnum;
  $('body').append(
    `<div class="confimk confim_${num}"><div class="confim_mould"><div class="confim_text">${obj.text}</div><div class="confim_btns"><div class="confim_btn confim_btn_cancel">${$.i18n.prop('string_cancel')}</div><div class="confim_btn confim_btn_submit">${$.i18n.prop('string_request_define')}</div></div></div></div>`
  );
  $(`.confim_${num}`).on("click", '.confim_btn_cancel', function () {
    $(this).parents(".confimk").remove();
    if (obj.cancelfn) {
      obj.cancelfn()
    }
  }).on("click", '.confim_btn_submit', function () {
    $(this).parents(".confimk").remove();
    if (obj.submitfn) {
      obj.submitfn()
    }
  })
}

function gdjz (el, offset, callback) {
  let dom = document.querySelector(el)
  if (dom) {
    var a, b, c, d;
    d = getElementToPageTop(dom) // 元素距离相对父级的高度，这里父级指的是body
    a = eval(d + offset)
    b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
    c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
    if (b + c > a) {
      callback && callback()
    }
  }
}

function getElementToPageTop (el) {
  if (el.parentElement) {
    return el.parentElement.offsetTop + el.offsetTop
  }
  return el.offsetTop
}

function getpagename () {
  return location.pathname.slice(location.pathname.lastIndexOf("/") + 1)
}

function getfiletype (name) {
  return name.slice(name.lastIndexOf(".") + 1) || ''
}

function runHandlebar (data, template, placeholder, isappend) {
  var temp = Handlebars.compile($("#" + template).html());
  if (isappend == 'prepend') {
    $("#" + placeholder).prepend(temp({
      datas: data
    }));
  } else if (isappend) {
    $("#" + placeholder).append(temp({
      datas: data
    }));
  } else {
    $("#" + placeholder).html(temp({
      datas: data
    }));
  }
}

function getQuery (variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return decodeURI(pair[1]);
    }
  }
  return (false);
}

function loadProperties (callback) {
  // jQuery.i18n.properties({//加载资浏览器语言对应的资源文件
  //     name:'strings', //资源文件名称
  //     path:'./static/i18n/', //资源文件路径
  //     mode:'map', //用Map的方式使用资源文件中的值
  //     language:$store.state.language,
  //     callback: function(res) {//加载成功后设置显示内容
  //         callback()
  //     }
  // });
}

function formattime (time, format, options) {
  let date = new Date(time)
  var o = {
    "M+": date.getMonth() + 1, //month
    "d+": date.getDate(), //day
    "h+": date.getHours(), //hour
    "m+": date.getMinutes(), //minute
    "s+": date.getSeconds(), //second
    "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
    "S": date.getMilliseconds() //millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
}
//时间戳转日期
function timestampToTime (date) {
  var date = new Date(date);
  var YY = date.getFullYear() + '年';
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + "日";
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + '';
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return YY + MM + DD + " " + hh + "" + mm;
}
function timestampToTimeCode (date) {
  var date = new Date(date);
  var YY = date.getFullYear() + '.';
  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '.';
  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + "";
  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + '';
  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return YY + MM + DD + " " + hh + "" + mm;
}
function formatprice (price, type) {
  price = (price / 100).toFixed(2)
  if (type == -1) { //type -1 去零
    price -= 0
  }
  return price
}

function formatdou (price, type) {
  var money = (price / 1000).toFixed(2)
  if (money && money != null) {
    money = String(money);
    var left = money.split('.')[0],
      right = money.split('.')[1];
    right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
    var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
    return (Number(money) < 0 ? "-" : "") + temp.join(',').split('').reverse().join('') + right;
  } else if (money === 0) { //注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
    return '0.00';
  } else {
    return "";
  }
}
/**3位数字加逗号 转换 */
function toThousands (num) {
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
}
//除法函数，用来得到精确的除法结果
//说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
//调用：accDiv(arg1,arg2)
//返回值：arg1除以arg2的精确结果
function accDiv (arg1, arg2) {
  var t1 = 0,
    t2 = 0,
    r1, r2;
  try {
    t1 = arg1.toString().split(".")[1].length
  } catch (e) { }
  try {
    t2 = arg2.toString().split(".")[1].length
  } catch (e) { }
  r1 = Number(arg1.toString().replace(".", ""));
  r2 = Number(arg2.toString().replace(".", ""));
  if (r2 == 0) {
    return Infinity;
  } else {
    return (r1 / r2) * Math.pow(10, t2 - t1);
  }
}
//乘法函数，用来得到精确的乘法结果
//说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
//调用：accMul(arg1,arg2)
//返回值：arg1乘以arg2的精确结果
function accMul (arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length
  } catch (e) { }
  try {
    m += s2.split(".")[1].length
  } catch (e) { }

  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}
//加法函数，用来得到精确的加法结果
//说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
//调用：accAdd(arg1,arg2)
//返回值：arg1加上arg2的精确结果
function accAdd (arg1, arg2) {
  var r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}
//减法函数
function accSub (arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  //last modify by deeka
  //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return ((arg2 * m - arg1 * m) / m).toFixed(n);
}


// //给Number类型增加一个add方法，调用起来更加方便。
// Number.prototype.add = function(arg) {
//   return accAdd(arg, this);
// };
// //给Number类增加一个sub方法，调用起来更加方便
// Number.prototype.sub = function(arg) {
//   return accSub(arg, this);
// };
// //给Number类型增加一个mul方法
// Number.prototype.mul = function(arg) {
//   return accMul(arg, this);
// };
// //给Number类型扩展一个div方法
// Number.prototype.div = function(arg) {
//   return accDiv(this, arg);
// };

var Position = {};
Position.getAbsolute = function (reference, target) {
  //因为我们会将目标元素的边框纳入递归公式中，这里先减去对应的值
  var result = {
    left: -target.clientLeft,
    top: -target.clientTop
  }
  var node = target;
  while (node != reference && node != document) {
    result.left = result.left + node.offsetLeft + node.clientLeft;
    result.top = result.top + node.offsetTop + node.clientTop;
    node = node.parentNode;
  }
  if (isNaN(reference.scrollLeft)) {
    result.right = document.documentElement.scrollWidth - result.left;
    result.bottom = document.documentElement.scrollHeight - result.top;
  } else {
    result.right = reference.scrollWidth - result.left;
    result.bottom = reference.scrollHeight - result.top;
  }
  return result;
}
Position.getViewport = function (target) {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft;
  var windowHeight = window.innerHeight || document.documentElement.offsetHeight;
  var windowWidth = window.innerWidth || document.documentElement.offsetWidth;
  var absolutePosi = this.getAbsolute(document, target);
  var Viewport = {
    left: absolutePosi.left - scrollLeft,
    top: absolutePosi.top - scrollTop,
    right: windowWidth - (absolutePosi.left - scrollLeft),
    bottom: windowHeight - (absolutePosi.top - scrollTop)
  }
  return Viewport;
}
Position.isViewport = function (target) {
  var position = this.getViewport(target);
  //这里需要加上元素自身的宽高，因为定位点是元素的左上角
  if (position.left + target.offsetWidth < 0 || position.top + target.offsetHeight < 0) {
    return false;
  }
  if (position.bottom < 0 || position.right < 0) {
    return false;
  }
  return true;
}


function setWechatShareContent (title, desc, userShareStr, shareImgUrl) {
  console.log(title, desc, userShareStr, shareImgUrl, $fetchql)
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    let parms = {
      pageurl: window.location.href,
    };
    $fetchql.fetchql.Post("getJsSDKSign", parms).then((res) => {
      // console.log("微信sdk");
      if (res.code == 0) {
        let appId = res.data.appId;
        let timestamp = res.data.timestamp;
        let nonceStr = res.data.nonceStr;
        let signature = res.data.signature;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appId, // 必填，公众号的唯一标识，填自己的！
          timestamp: timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名，见附录1
          jsApiList: ["checkJsApi", "updateTimelineShareData", "updateAppMessageShareData", "onMenuShareAppMessage",
            "updateAppMessageShareData"]
        });

        wx.ready(function () {
          // var title = '薄盒Mints';
          // var desc = '薄盒Mints';
          var theUrl = window.location.href + userShareStr
          // var shareImgUrl = 'https://cdn.mintstech.cn/favicon.ico';
          //分享到朋友圈
          wx.updateTimelineShareData({
            title: title, // 分享时的标题
            link: theUrl, // 分享时的链接
            imgUrl: shareImgUrl, // 分享时的图标
            success: function () {
              console.log("分享成功");
            },
            cancel: function () {
              console.log("取消分享");
            },
            fail: function (res) {
              console.log("fail" + JSON.stringify(res));
            },
            complete: function (res) {
              //接口调用完成时执行的回调函数，无论成功或失败都会执行。
              console.log("complete" + JSON.stringify(res));
            }
          });
          //分享给朋友
          wx.updateAppMessageShareData({
            title: title,
            desc: desc,
            link: theUrl,
            imgUrl: shareImgUrl,
            success: function () {
              console.log("分享成功");
            },
            cancel: function () {
              console.log("取消分享");
            },
            fail: function (res) {
              console.log("fail" + JSON.stringify(res));
            },
            complete: function (res) {
              //接口调用完成时执行的回调函数，无论成功或失败都会执行。
              console.log("complete" + JSON.stringify(res));
            }
          });
          wx.onMenuShareAppMessage({
            title: title,
            desc: desc,
            link: theUrl,
            imgUrl: shareImgUrl,
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果 type 是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户点击了分享后执行的回调函数
            }
          });
          wx.updateAppMessageShareData({
            title: title,
            desc: desc,
            link: theUrl,
            imgUrl: shareImgUrl,
            success: function () {
              // 设置成功
            }
          })

        });
        wx.error(function (res) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          console.log("myerr:" + JSON.stringify(res));
        });
      } else {
        this.$message.error("获取签名失败");
      }
    }).catch((error) => {
      console.log(error);
    });
  }
}
export default {
  showSuccess,
  showError,
  showconfim,
  getpagename,
  getfiletype,
  runHandlebar,
  getQuery,
  loadProperties,
  formatdou,
  formatprice,
  formattime,
  timestampToTime,
  toThousands,
  accDiv,
  accMul,
  accAdd,
  accSub,
  timestampToTimeCode,
  Position,
  setWechatShareContent
}



// WEBPACK FOOTER //
// ./src/common/tool.js